import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const defaults = [
  { day: 'Sunday', time: '11:00 AM', name: 'Sunday Worship' },
  { day: 'Wednesday', time: '7:00 PM', name: 'Bible Study' },
  { day: 'Friday', time: '7:30 PM', name: 'Prayer Night' },
];

let cached = null;

export const useServiceTimes = () => {
  const [services, setServices] = useState(cached || defaults);

  useEffect(() => {
    if (cached) { setServices(cached); return; }
    axios.get(`${API}/api/service-times`)
      // Vine Night entries show only on the VINE page, not in general service-time lists.
      .then(res => { cached = (res.data.services || []).filter((s) => !/vine/i.test(s.name || '')); setServices(cached); })
      .catch(() => setServices(defaults));
  }, []);

  return services;
};
